import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(default)/salaries/page-content.tsx");
